var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CToaster',{staticClass:"toast-wrapper",attrs:{"position":_vm.config.position}},_vm._l((_vm.list),function(toast){return _c('ToastBox',{key:toast.key,attrs:{"toast":toast}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }